/** Bottom progress-bar for TimesheetDetailPage.
 *
 * Mirrors the AttentionCounter at the top: shows the live cell-status
 * breakdown so Birgit sees the attention budget shrink as she works.
 * Includes the auto-fixed and ignoriert counts which the top banner hides
 * (those are "no work" buckets and don't belong in the attention count).
 */
import type { CellStatus } from "../lib/cellStatus";
import { STATUS_ICONS } from "../lib/cellStatus";

interface Props {
  breakdown: Record<CellStatus, number>;
}

export function ProgressTracker({ breakdown }: Props) {
  const total =
    breakdown.korrigieren + breakdown.pruefen + breakdown.autoFixed +
    breakdown.ignoriert + breakdown.ok;

  return (
    <div className="progress-tracker" role="status" aria-label="Zellen-Status">
      <span className="pt-segment pt-ok" title="ok">
        <span aria-hidden="true">{STATUS_ICONS.ok}</span> {breakdown.ok}
      </span>
      <span className="pt-segment pt-auto" title="auto-repariert">
        <span aria-hidden="true">{STATUS_ICONS.autoFixed}</span> {breakdown.autoFixed}
      </span>
      <span className="pt-segment pt-pruefen" title="prüfen">
        <span aria-hidden="true">{STATUS_ICONS.pruefen}</span> {breakdown.pruefen}
      </span>
      <span className="pt-segment pt-korrigieren" title="korrigieren">
        <span aria-hidden="true">{STATUS_ICONS.korrigieren}</span> {breakdown.korrigieren}
      </span>
      {breakdown.ignoriert > 0 && (
        <span className="pt-segment pt-ignoriert" title="ignoriert (Marginalia)">
          <span aria-hidden="true">{STATUS_ICONS.ignoriert}</span> {breakdown.ignoriert}
        </span>
      )}
      <span className="pt-total" aria-live="polite">{total} Zellen gesamt</span>
    </div>
  );
}
